import AddPlans from "../pages/addPlans";
import Dashboard from "../pages/dashboard";
import Feeds from "../pages/feeds";

import { lazyLoad } from "../utils/lazyLoad";

const Home = lazyLoad(() => import("../pages/home/index"));
const Login = lazyLoad(() => import("../pages/login"));
const AllStock = lazyLoad(() => import("../pages/allStock"));
const Subscription = lazyLoad(() => import("../pages/subscription"));
const Faq = lazyLoad(() => import("../pages/FAQ/FaqDetail.js"));
const CoupenPage = lazyLoad(() => import("../pages/Coupen/index"));
const Reports = lazyLoad(() => import("../pages/reports/Reports.js"));
const routes = [
  {
    path: "/home",
    element: Home,
  },
  {
    path: "/coupon",
    element: CoupenPage,
  },
  {
    path: "/dashboard",
    element: Dashboard,
  },
  {
    path: "/",
    element: Login,
  },
  {
    path: "/stock",
    element: AllStock,
  },
  {
    path: "/subscription",
    element: Subscription,
  },
  {
    path: "/addplans",
    element: AddPlans,
  },
  {
    path: "/feed",
    element: Feeds,
  },
  {
    path: "/faq",
    element: Faq,
  },
  {
    path: "/reports",
    element: Reports,
  },
  // {
  //   path: '/about',
  //   element: About,
  //   isProtected: false,
  // }
];

export default routes;
